<template>
  <div class="f-r container">
    <basic-form
      class="input-form"
      ref="palletForm"
      title="Pallet Info"
      :show-clear="true"
      :mode="FormModes.SINGLE"
      :form-params="palletForm"
      :change-date="val => (date = val)"
      :value-change-cb="(key, val) => formValueChange(palletForm, key, val)"
    >
      <template v-slot:bottom-actions>
        <div class="f-r">
          <el-button size="small" type="primary" plain @click="addPallet">
            Add Pallets
          </el-button>
          <el-button size="small" type="danger" plain @click="clearInputs">
            Clear Inputs
          </el-button>
        </div>
      </template>
    </basic-form>
    <common-card title="Local Pallets" class="pallet-list">
      <basic-table
        :table-data="pageData"
        :table-headers="LocalPalletGroupHeaders"
        :has-actions="true"
        :has-row-expand="true"
        :action-min-width="130"
        rowKey="address.id"
        :checkExpand="() => true"
        :paginationChange="paginationChange"
        :showPagination="false"
        :summary="true"
      >
        <template v-slot:row-expand="props">
          <div class="f-c expand-detail">
            <span>FBA: {{ props.row.fba }}</span>
            <span>Customer Ref#: {{ props.row.refNo }}</span>
          </div>
        </template>
        <template v-slot:row-actions="props">
          <div class="actions f-r" style="flex-wrap: wrap;">
            <el-button
              size="small"
              type="text"
              class="remove-but"
              @click="removePallet(props.index)"
            >
              <div class="f-r-vc" style="gap: 5px;">
                <svg-icon icon-class="trash" class="svg-danger-color" />
                <span>Remove</span>
              </div>
            </el-button>
          </div>
        </template>
      </basic-table>
    </common-card>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import { FormModes } from '@/core/configs/types'
// models
import {
  LocalPalletForm,
  LocalPalletGroupHeaders,
  LocalPalletGroupWrapUp
} from '@/core/models/order'
// components
import BasicForm from '@/components/common/BasicForm.vue'
import CommonCard from '@/components/common/CommonCard.vue'
import BasicTable from '../common/BasicTable.vue'
export default {
  name: 'LocalPalletsAdd',
  components: {
    CommonCard,
    BasicForm,
    BasicTable
  },
  data() {
    return {
      FormModes,
      LocalPalletGroupHeaders,
      palletForm: cloneDeep(LocalPalletForm),
      pallets: []
    }
  },
  computed: {
    pageData() {
      return {
        records: this.pallets,
        total: this.pallets.length
      }
    }
  },
  methods: {
    paginationChange() {},
    formValueChange(form, key, val) {
      this.$set(get(form, key), 'value', val)
    },
    addPallet() {
      const [passed, formInputs] = this.$refs.palletForm.validateAllInputs()
      if (passed) {
        const index = this.pallets.findIndex(
          one => one.address.id === formInputs.address.id
        )
        if (index > -1) {
          this.$message.error('Duplicated factory no!')
          return
        }
        if (formInputs.palletCount <= 0) {
          this.$message.error('Pallet count must be large than 0!')
          return
        }
        this.pallets.push(cloneDeep(formInputs))
      }
    },
    removePallet(index) {
      this.pallets.splice(index, 1)
    },
    getAllPallets() {
      return this.pallets.map(one => {
        return LocalPalletGroupWrapUp(one)
      })
    },
    clearInputs() {
      //
      Object.values(this.palletForm).forEach(one => {
        one.value = one.default
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.container {
  width: calc(100% - 40px);
  margin: 10px 20px;
  gap: 20px;

  .common-card {
    margin: 0 !important;
  }

  .input-form {
    width: 50%;
  }

  .pallet-list {
    width: 50%;
    min-height: 500px;
    margin: 0 !important;
  }
}

.expand-detail {
  padding: 10px 20px;
  font-size: 15px;
}

.remove-but {
  color: rgba($deep-danger, 0.6);

  &:hover {
    color: $deep-danger;
  }
}
</style>
